import React, {useState} from 'react';
import './header.css';
import Logo from '../Images/Logo.png';

export default function Header() {
  const [open, setOpen] = useState(false);

  const handleHireUs = () => {
    setOpen(false);
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    window.dispatchEvent(new CustomEvent('zeitamax-open-contact'));
  };

  return (
    <header className="zm-header">
      <div className="zm-container zm-header-inner">
        <div className="zm-logo">
          <a href="#home" aria-label="Go to the top of the Zeitamax home page">
            <img className="logo" src={Logo} alt="Zeitamax logo" />
          </a>
        </div>

        <button className="mobile-toggle" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <nav className={`zm-nav ${open ? 'open' : ''}`}>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#industry">Industry</a>
          <a href="#careers">Careers</a>
          <a href="#jobs">Job Portal</a>
          <a href="#admin">Admin</a>
          <button type="button" className="cta" onClick={handleHireUs}>Hire Us</button>
        </nav>
      </div>

      {open && (
        <div className="mobile-nav" onClick={() => setOpen(false)}>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#industry">Industry</a>
          <a href="#careers">Careers</a>
          <a href="#jobs">Job Portal</a>
          <a href="#admin">Admin</a>
          <button type="button" className="cta" onClick={handleHireUs}>Hire Us</button>
        </div>
      )}
    </header>
  );
}
